export class PoInfo {
    poNumber: string;
    count: number;
    product?: string;
    quantity: number;
    /**
     * 
     * @param poNumber
     * @param product
     * @param quantity
     * @param count
     */
    constructor(poNumber: string,count: number,quantity: number,product?: string) {
        this.poNumber = poNumber;
        this.count = count;
        this.quantity = quantity;
        this.product = product;
    }
}